var map = {
	"./green.scss": "./src/vab/styles/themes/green.scss",
	"./ocean.scss": "./src/vab/styles/themes/ocean.scss",
	"./white.scss": "./src/vab/styles/themes/white.scss"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/vab/styles/themes sync \\.scss$";